import { render, staticRenderFns } from "./jobAdd.vue?vue&type=template&id=6398d952&scoped=true"
import script from "./jobAdd.vue?vue&type=script&lang=js"
export * from "./jobAdd.vue?vue&type=script&lang=js"
import style0 from "./jobAdd.vue?vue&type=style&index=0&id=6398d952&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6398d952",
  null
  
)

export default component.exports